import { Component, Input } from '@angular/core';
import { CmsImageAsset } from 'src/_model/storyblock';
import { CmsService } from 'src/_service/CmsService';

@Component({
  selector: 'app-cms-image',
  imports: [],
  templateUrl: './cms-image.component.html',
  styleUrl: './cms-image.component.scss'
})
export class CmsImageComponent {

  @Input() height: number
  @Input() width: number

  private _image: CmsImageAsset
  @Input() set image(value: CmsImageAsset) {
    this._image = value;

    if (this._image.filename) {
      const origWidth = Number(this._image.filename.split('/')[5].split('x')[0]);
      const origHeight = Number(this._image.filename.split('/')[5].split('x')[1]);

      if (this.height && !this.width) {
        this.width = Math.round( this.height * (origWidth /origHeight) ) 
      } else if (this.width && !this.height) {
        this.height = Math.round(this.width * (origHeight /origWidth) )
      }
    }

    this.imageSrc = this._cmsService.get_src(this._image, this.contain, this.height, this.width);
    this.imageAlt = this._cmsService.get_alt(this._image);
  }
  get image() { return this._image }

  @Input() imageClass: string
  imageSrc: string
  imageAlt: string

  @Input() contain: boolean = false
  @Input() loadEager: boolean = false
  // @Input() ratio: imageratio = imageratio.LANDSCAPE

  constructor(
    private _cmsService: CmsService
  ) {

  }
}
